// extracted by mini-css-extract-plugin
export var container = "_ow-0";
export var dotAnimation = "_ow-2";
export var dotsLoading = "_ow-1";